/** Common choices; existing company departments remain selectable. */
export const COMPANY_DEPARTMENTS: readonly string[] = [
    'Dirección general',
    'Administración',
    'Finanzas y contabilidad',
    'Recursos humanos',
    'Comercial y ventas',
    'Marketing',
    'Comunicación y relaciones públicas',
    'Atención al cliente',
    'Compras',
    'Logística y distribución',
    'Operaciones',
    'Producción',
    'Tecnología y sistemas de información',
    'Investigación, desarrollo e innovación',
    'Calidad',
    'Mantenimiento',
    'Legal y cumplimiento normativo',
    'Prevención de riesgos laborales',
    'Sostenibilidad y medioambiente',
    'Servicios generales'
];

export function companyDepartmentOptions(existing: (string | null | undefined)[] = []): string[] {
    return [...new Set([...COMPANY_DEPARTMENTS, ...existing.filter(name => !!name?.trim())])];
}
